/**
 * Remembers the feed tab an event selection navigated away from, so deselecting
 * can put the user back.
 *
 * Deselect must name a tab explicitly: NewsCountComponent treats a missing
 * `newstype` as "restore the last one" from its own cached value, which bounces
 * the user straight back to Events and strands them on its placeholder.
 */
export class EventTabMemory {
  private stored: string | null = null;

  resolve(opts: {
    selecting: boolean;
    forcesEventsTab: boolean;
    current: string | null | undefined;
  }): string | null {
    const { selecting, forcesEventsTab, current } = opts;

    if (selecting) {
      if (!forcesEventsTab) {
        return current ?? null;
      }
      if (current !== 'Events') {
        this.stored = current ?? null;
      }
      return 'Events';
    }

    const previous = this.stored;
    this.stored = null;
    if (previous) {
      return previous;
    }
    // Only override when the selection actually stranded them on Events.
    return current === 'Events' ? 'Chronological' : (current ?? null);
  }
}
